import { createContext } from 'react';
import { PriceData } from './Domain/PriceTable';

export const PricesContext = createContext<PriceData | null>(null);